import {
	augmentedRealityStart,
	infoGetOS,
	augmentedRealityGetVersion,
} from '@/tools/nativeInterfaceFunctions';
import Vue from 'vue';
import { actionTypes, errorTypes } from '@/types';
import { logger } from '@/tools/logger';

export async function augmentedRealityPackageLoader(arRootURL, store) {
	const { currentLanguage } = store.getters;
	const { currentAugmentedRealityArticle } = store.state;

	let data = {};
	const result = await Vue.http.get(`${arRootURL}/index.json`);
	if (result.error) {
		store.dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.arDescriptionNotLoaded) });
		return null;
	}
	data = JSON.parse(JSON.stringify(result.body).replace(/\*SYSTEM\*/g, (await infoGetOS()).toLowerCase()));

	// TODO: Include fallback langauge filterting
	if (data.AssetbundleProperties) {
		data.Prefab.forEach((prefab) => {
			if (prefab.markerPath) prefab.markerPath = `${arRootURL}/${prefab.markerPath}`;
			if (prefab.modelPath) {
				prefab.modelPath = prefab.modelPath
					.split(';')
					.map((path) => `${arRootURL}/${path}`)
					.join(';');
			}
			prefab.I18nGameobject.forEach((gameObject) => {
				gameObject.I18nText = gameObject.I18nText
					? gameObject.I18nText.filter((text) => text.languageISO === currentLanguage)
					: gameObject.I18nText;
			});
		});
		data.I18nInstruction = data.I18nInstruction
			? data.I18nInstruction.filter((instruction) => instruction.languageISO === currentLanguage)
			: data.I18nInstruction;
	}
	// AR engine vs. asset version comparison
	const arEngineVersion = await augmentedRealityGetVersion();
	const assetArEngineVersion = data.AssetbundleProperties.arEngineVersion;

	if (
		(typeof arEngineVersion === 'undefined' && typeof assetArEngineVersion !== 'undefined') ||
		(typeof arEngineVersion !== 'undefined' &&
			typeof assetArEngineVersion !== 'undefined' &&
			arEngineVersion != assetArEngineVersion)
	) {
		store.dispatch(actionTypes.sendErrorMessage, {
			error: errorTypes(errorTypes.augmentedRealityEngineVersionMissmatch),
		});
	}
	// Add matomo analytics
	data.analyticsInfo = {};
	const matomoTracker = window.Piwik && window.Piwik.getAsyncTracker();
	if (matomoTracker) {
		data.analyticsInfo = {
			baseURL: matomoTracker.getPiwikUrl(), // the base URL of the tracking system like https://athena.cms.shoutrlabs.com/etna/
			siteId: matomoTracker.getSiteId(),
			url: window.location.href, // the url of the requested ar article
			userId: matomoTracker.getVisitorId(), // the unique user id
		};
	}

	// Add currently playing audio objects
	// data.PlayingMediaObjects = {};
	if (store.state.playerAudio.playerState == 'playing') {
		/*
		const { mediaID, title, description, source, duration, currentTime } = store.state.playerAudio;
		data.PlayingMediaObjects = {
			id: mediaID,
			type: 'audio',
			I18nContent: [{ languageISO: currentLanguage, title, description, source, duration }],
			position: currentTime,
		};*/
		store.dispatch(actionTypes.audioClose);
	}
	data.ArticleLanguageContent = currentAugmentedRealityArticle.languageContent.filter(
		(lc) => lc.languageISO === currentLanguage
	);

	// Add external media objets that can be used in the AR
	const imageSize = store.state.imageSize || 1024;
	data.ExternalMediaObjects = currentAugmentedRealityArticle.arContent.externalMediaObjects.map(
		(mediaObject) =>
			Object.assign({}, mediaObject, {
				languageContent: mediaObject.languageContent
					.filter((lc) => lc.languageISO === currentLanguage)
					.map((lc) =>
						Object.assign({}, lc, {
							sourceUrl: `${store.state.dataSourceURL}apps/${
								mediaObject.type === 'image' ? `media-${lc.source}/${imageSize}` : lc.sourceUrl
							}`,
						})
					),
			})
	);

	// Overwrite markers set by users of the CMS that were not part of the original AR package
	const { externalMediaMarkers } = currentAugmentedRealityArticle.arContent;
	const mediaObjectToMediaFile = store.state.dataSourceCFG.mediaObjectsInfo.mediaObjects;
	if (externalMediaMarkers) {
		const prefabNameToMediaFile = externalMediaMarkers.reduce(
			(acc, { prefabName, mediaObjectID }) =>
				Object.assign(acc, {
					[prefabName]: `${store.state.dataSourceURL}apps/media-${mediaObjectToMediaFile[mediaObjectID][currentLanguage]}/${imageSize}`,
				}),
			{}
		);
		data.Prefab.filter(({ name }) => name in prefabNameToMediaFile).forEach(({ name, ExternalMediaInfo }) => {
			const emi = ExternalMediaInfo.find(({ isMarker }) => isMarker);
			emi.sourceUrl = prefabNameToMediaFile[name];
		});
	}

	/* eslint-disable no-useless-escape */
	logger.log('Augmented reality data: ', JSON.stringify(data).replace(/\"/g, '"'));
	logger.log(`"${JSON.stringify(data).replace(/"/g, '\\"')}"`);
	/* eslint-disable no-console */
	console.log('Augmented reality data:'); // remove when nativeAppDoLog works
	console.log(`"${JSON.stringify(data).replace(/"/g, '\\"')}"`);
	await augmentedRealityStart(JSON.stringify(data));
}
